import React from "react";
import { Input } from "./ui/Input";

export function SearchInput(props: {
  value: string | undefined;
  performSearch: (isNewSearch: boolean) => void;
  setSearchTerm: (v: string) => void;
  placeholder?: string;
  dataCy?: string;
  filterActive?: boolean;
  noWFull?: boolean;
}) {
  const wFull = props.noWFull ? "flex-1" : "w-full";
  return (
    <div className={"relative flex " + wFull + " items-center"}>
      <svg
        aria-hidden
        className="pointer-events-none absolute left-3 h-5 w-5 text-ink-muted"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="11" cy="11" r="8" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
      </svg>
      <Input
        type={"search"}
        data-cy={props.dataCy}
        value={props.value}
        placeholder={props.placeholder}
        onKeyDown={(e) => {
          if (e.key == "Enter") {
            props.performSearch(true);
          }
        }}
        noWFull
        onChange={(e) => props.setSearchTerm(e.target.value)}
        className={"flex-1 pl-10"}
      />
    </div>
  );
}
